import React from "react"
import { Box, Typography } from "@mui/material"
import * as Style from "./style"
import { useParams } from "react-router-dom"
import {
  useAcceptGenrateBookingQuery,
  useGetPostTimeLineQuery,
} from "../../features/OverViewAuth/overViewApi"
import {
  Timeline,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
  TimelineConnector,
  TimelineDot,
  TimelineContent,
} from "@mui/lab"
import moment from "moment"
import CenteredSpinner from "../common/CenteredSpinner"

interface Props {
  dateString: string
}

export function FormatDate({ dateString }: Props) {
  const utcDate = moment.utc(dateString).local()
  return <>{utcDate.format("dddd")}</>
}

export function FormatTime({ dateString }: Props) {
  const utcDate = moment.utc(dateString).local()
  return <div>{utcDate.format("D-MMMM")}</div>
}

export function FormatChangeTime({ dateString }: Props) {
  const utcDate = moment.utc(dateString).local()
  return <div> {utcDate.format("h:mm A")}</div>
}

export function FormatDateMonthDay({ dateString }: Props) {
  const utcDate = moment.utc(dateString).local()
  return <div>{utcDate.format("DD MMM, dddd")}</div>
}

const BookingServiceDetails = () => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const { id } = useParams()
  const {
    data: timeLine,
    isLoading: timeisLoading,
    isFetching: timeisFetching,
  } = useGetPostTimeLineQuery({ id })

  const {
    data: acceptedGenrate,
    isLoading,
    isFetching,
  } = useAcceptGenrateBookingQuery({ id })

  return (
    <>
      {timeisLoading || timeisFetching || isLoading || isFetching ? (
        <CenteredSpinner />
      ) : (
        <Box className="pt-5 px-5">
          <Style.Overview>
            <Box
              className="d-flex mb-5"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography align="left" variant="h2" mb={2}>
                Timeline
              </Typography>
            </Box>
            <Box className="timeline-graph">
              {timeLine?.data?.map((timeline: any, index: number) => (
                <Timeline
                  key={timeline._id}
                  position={index % 2 === 0 ? "alternate" : "left"}
                >
                  <TimelineItem>
                    <TimelineOppositeContent
                      sx={{ m: "10px 0 0" }}
                      align="right"
                      className="timeline-desc"
                      color="text.secondary"
                    >
                      <FormatDateMonthDay dateString={timeline.createdAt} />
                      <FormatChangeTime dateString={timeline.updatedAt} />
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineConnector />
                      <TimelineDot>
                        <Typography className="timeline-step">
                          {++index}
                        </Typography>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: "12px", px: 2 }}>
                      <Box className="timeline-content">
                        <Typography className="timeline-heading">
                          Status {timeline?.postStatus}
                        </Typography>

                        <Typography className="timeline-desc"></Typography>
                        <Typography className="timeline-desc">
                          {timeline?.message}{" "}
                        </Typography>
                      </Box>
                    </TimelineContent>
                  </TimelineItem>
                </Timeline>
              ))}
            </Box>
          </Style.Overview>
        </Box>
      )}
    </>
  )
}
export default BookingServiceDetails
